import { Box, Button, H1, Text } from '@betterment/samba-react';

export const ReclaimSignature: React.FC<
  React.PropsWithChildren<{ loading: boolean; onReclaimSignature: VoidFunction }>
> = ({ loading, onReclaimSignature }) => {
  return (
    <Box
      css={{ mb: 'space.400', p: 'space.300', borderStyle: 'solid', borderWidth: 'thin', borderColor: 'border.weak' }}
    >
      <Box css={{ display: 'flex' }}>
        <Box css={{ flexGrow: '1' }}>
          <H1 variant="title100">Are you the contract signer?</H1>
          <Text>If so, you may also sign the document on this page.</Text>
        </Box>
        <Button
          loading={loading}
          onClick={() => onReclaimSignature()}
          disabled={loading}
          css={{ height: 'size.300', width: '200px' }}
        >
          Sign document here
        </Button>
      </Box>
    </Box>
  );
};
